import moment from "moment"

// Year to Date Dashboard filters
const getDefaultYears = () => {
	const currentYear = moment().year()
	const years = []
	// Start from 2023 up to current year, max 5 years
	for (let y = Math.max(2023, currentYear - 4); y <= currentYear; y++) {
		years.push(y)
	}
	return years
}

const getDefaultState = () => {
	return {
		filters: {
			selectedYears: getDefaultYears(),
			selectedEntities: [],
			selectedClassSubclasses: [],
			market: "",
			includeMtas: true,
			currentPage: 0,
		},
	}
}

export const state = () => getDefaultState()

export const mutations = {
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
	SET_FILTER(state, { filterName, value }) {
		state.filters[filterName] = value
	},
}

export const actions = {
	reset({ commit }) {
		commit("RESET_STATE")
	},
	updateFilter({ commit }, { filterName, value }) {
		commit("SET_FILTER", { filterName, value })
	},
}

export const getters = {
	getFilters(state) {
		return state.filters
	},
	getFilter: (state) => (filterName) => {
		return state.filters[filterName]
	},
}
